export default __webpack_public_path__ + "static/media/not-sure-whats-wrong-white.8d27d169.svg";